export type Project = {
  title: string;
  period: string;
  description: string;
  stack: readonly string[];
  href?: string;
};

export const projects: readonly Project[] = [
  {
    title: 'tkasparaitis.io',
    period: '2026',
    description:
      "The site you're reading. Built on a stack I don't use at work (Java, Spring, Postgres, GCP, Terraform) to actually learn it. Over-built on purpose: containers, managed Postgres, infrastructure as code, CI/CD.",
    stack: ['Java 21', 'Spring Boot', 'Postgres', 'GCP', 'Terraform', 'React'],
  },
  {
    title: 'Job Aggregator',
    period: '2023 — 2025',
    description:
      'A personal pipeline that scraped job boards with Python and SeleniumBase. About 2 million postings into Postgres on AWS RDS, run on Airflow, with SQL filtering to cut the noise. Retired now.',
    stack: ['Python', 'SeleniumBase', 'PostgreSQL', 'AWS RDS', 'Airflow'],
  },
  {
    title: 'Email Delivery API',
    period: '2024',
    description:
      'A small C# / ASP.NET Core service with Razor Pages and EF Core over SQLite. Delivery verified with Mailtrap, tested with Postman and Swagger.',
    stack: ['C#', 'ASP.NET Core', 'EF Core', 'SQLite'],
  },
];
